import './style.css';

import { useService } from '@policoders/di';
import { useEffect, useState } from 'react';

import LoaderService from './loader.service';

export const LoaderFull = () => {
  const service = useService<LoaderService>('LoaderService');
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const sub = service.state$.subscribe(state => {
      setShow(state.loading);
    });
    return () => {
      sub.unsubscribe();
    };
  });

  return (
    <div className={`loader-full${!show ? ' hidden' : ''}`}>
      <div className="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
